import { get } from '@/lib/http';

export default {
  // 通过音频id获取当前音频目录下所有音频
  // id	是	String	音频ID
  async getCatalogByResourceId(resourceListeningResourceId) {
    const res = await get(
      `/api/v3/server_resource/listening/resource/${resourceListeningResourceId}`
    ).catch((error) => {
      throw error;
    });
    return res;
  },
  // 获取系统安全码
  // clientSessionId	xxxxx	string	当前请求SESSION 唯一性值
  // t	123456789	int	请求当前时间戳。与服务器时间超出3分钟，算非法请求！
  // client	xxxxx	string	请求客户端来源：front、manage、pc、android、pad、ios、ipad
  // encrypt	xxxxx	string	请求安全校验签名
  async getSafeCode(params) {
    const res = await get(`/api/v3/server_system/system/code`, params).catch(
      (error) => {
        throw error;
      }
    );
    return res;
  },
  async getMessageServer(params) {
    const res = await get(`/api/v3/server_system/version/last`, params).catch(
      (error) => {
        throw error;
      }
    );
    return res;
  },
};
